var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-content" }, [
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-pink-53 w140 mr-3 btn-up-img",
          on: {
            click: function($event) {
              return _vm.upload()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("button.ok")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-upload-img mr-3 w140 btn-up-img",
          style: { display: _vm.isCanOcr() ? "none" : "" },
          on: { click: _vm.selectFiles }
        },
        [_vm._v(_vm._s(_vm.$t("button.add_file")))]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-gray-53 w140 btn-up-img",
          on: {
            click: function($event) {
              return _vm.cancelUpload()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("button.cancel")))]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex", staticStyle: { "margin-top": "0.5rem" } },
      [
        _c(
          "div",
          { staticClass: "bg-gray-btm mr-3 g-checkbox" },
          [
            _vm._l(_vm.ocrList, function(s) {
              return _c("label", { key: s.id, staticClass: "radio-ocr" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedOcr,
                      expression: "selectedOcr"
                    }
                  ],
                  staticClass: "radioicon-ocr",
                  attrs: {
                    type: "radio",
                    name: "radioOCr",
                    disabled: !_vm.isCanOcr()
                  },
                  domProps: {
                    value: s.id,
                    checked: _vm._q(_vm.selectedOcr, s.id)
                  },
                  on: {
                    click: function($event) {
                      return _vm.selectOcr(s.id)
                    },
                    change: function($event) {
                      _vm.selectedOcr = s.id
                    }
                  }
                }),
                _vm._v("\n                " + _vm._s(s.name) + "\n            ")
              ])
            }),
            _vm._v(" "),
            _c("label", { staticClass: "checkbox-custom f-w-300" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.handwriteOcr,
                    expression: "handwriteOcr"
                  }
                ],
                attrs: {
                  type: "checkbox",
                  name: "handwriteOcr",
                  disabled: !_vm.ocr
                },
                domProps: {
                  checked: Array.isArray(_vm.handwriteOcr)
                    ? _vm._i(_vm.handwriteOcr, null) > -1
                    : _vm.handwriteOcr
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.handwriteOcr,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.handwriteOcr = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.handwriteOcr = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.handwriteOcr = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _vm.ocr
                ? _c("span", { staticClass: "checkmark" })
                : _c("i", { staticClass: "checkmark-disabled" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("voucher.ocr.handwriting")))])
            ])
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "info-dragAndDrop" }, [
      _vm._v("ドラッグ＆ドロップでファイルの並び替えができます。")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box-img" },
      [
        _c(
          "draggable",
          {
            model: {
              value: _vm.files,
              callback: function($$v) {
                _vm.files = $$v
              },
              expression: "files"
            }
          },
          _vm._l(_vm.files, function(file, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "preview lst-img",
                attrs: {
                  href: "#",
                  "data-dismiss": "modal",
                  "data-toggle": "modal"
                },
                on: {
                  click: function($event) {
                    return _vm.showThumb(file)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "file-preview" },
                  [
                    file.type === "image/tiff"
                      ? _c(
                          "div",
                          {
                            staticClass: "thumb-tiff",
                            attrs: { id: "tiff_" + index }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.loadImage(file.url, "tiff_" + index))
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    file.type === "application/pdf"
                      ? _c("pdf", {
                          staticClass: "thumb-pdf",
                          attrs: { src: file.url }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    file.type === "image/png" ||
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg"
                      ? _c("img", {
                          staticClass: "preview-upload",
                          attrs: { src: file.url }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "text-img" }, [
                  _c("p", { staticClass: "fs-13 text-truncate" }, [
                    _vm._v(_vm._s(file.name))
                  ])
                ])
              ]
            )
          }),
          0
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-pink-53 w140 mr-3 btn-up-img",
          on: {
            click: function($event) {
              return _vm.upload()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("button.ok")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-227950b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227950b7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Voucher/PreviewFileUpload.vue
// module id = null
// module chunks = 